import { gql } from '@apollo/client';

export default gql`
  subscription removeNotificationSubscription($userId: String!) {
    removeNotificationSubscription(userId: $userId) {
      uuid
    }
  }
`;
